import { memo, useMemo } from 'react'
import { Card, CardBody, CardHeader, TruncateText, classNames } from '@panwds/react-ui'
import type { ReactNode, VFC } from 'react'
import type { ReadonlyTsgTree, Tsg } from '@sparky/framework'

type AppsCardProps = {
  tsg: Tsg
  tsgs: ReadonlyTsgTree
  children: ReactNode
  isSingleTenantOnly?: boolean
}

const AppsCard: VFC<AppsCardProps> = ({ children, tsg, isSingleTenantOnly }) => {
  const subtitle = useMemo(() => {
    if (isSingleTenantOnly) {
      return null
    }
    const { id, display_name } = tsg
    return (
      <>
        <TruncateText addClassName='cm-block cm-h-4 cm-whitespace-nowrap'>{display_name}</TruncateText>
        <small className='cm-block cm-h-3 cm-whitespace-nowrap cm-overflow-hidden'>TSG ID: {id}</small>
      </>
    )
  }, [tsg, isSingleTenantOnly])
  return (
    <Card
      dataTestId='switcher-apps-card'
      addClassName='switcher-apps-card cm-w-full cm-h-full cm-m-0 cm-rounded-none cm-border-0 cm-border-l dark:cm-border-l cm-text-white cm-bg-blue-steel-950 dark:tw-border-gray-950'
    >
      <CardHeader
        dataTestId='switcher-apps-card-header'
        title={isSingleTenantOnly ? 'AVAILABLE APPS' : 'AVAILABLE APPS for'}
        subTitle={subtitle}
        addClassName={classNames('switcher-apps-card-header tw-dark', isSingleTenantOnly ? 'cm-h-9 cm-border-b-0' : 'cm-text-sm cm-h-16')}
      />
      <CardBody addClassName='cm-p-0 cm-h-full cm-overflow-hidden'>{children}</CardBody>
    </Card>
  )
}

export default memo(AppsCard)
